"use strict";

import {findAll, on, closest, addClass, removeClass, findIn, find} from '@elements/dom-utils';
import {onFind} from '@elements/init-modules-in-scope';

export function init() {
    onFind('.js-filter__button-filter', button => {
        let filterOverlay = find('.js-filter__overlay');
        let close = findIn('.js-filter__button-close', filterOverlay);
        let cancel = findIn('.js-filter__button-cancel', filterOverlay);
        let save = findIn('.js-filter__button-save', filterOverlay);

        on('click', (e) => {
            addClass('is-active', filterOverlay);
        }, button);

        on('click', (e) => {
            removeClass('is-active', filterOverlay);
        }, close);

        on('click', (e) => {
            removeClass('is-active', filterOverlay);
        }, cancel);


        on('click', (e) => {
            removeClass('is-active', filterOverlay);
        }, save);
    });
}